import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'MaritalStatus', method: 'GET', body: null, token: token })
}
